import {
  BottomSheetContainer,
  Chip,
  createUseBottomSheetModal,
  Flex,
  Typography,
} from '@banhala/ui-kit';
import { useState } from 'react';
import { isNil, isNotNil } from '../../../../../utils';

export type FilterSelectItemValue = {
  queryName: string;
  queryValue: string;
  name: string;
};

export type FilterSelectBottomSheetParams = {
  title: string;
  itemList: { title: string; list: FilterSelectItemValue[] }[];
  selected: FilterSelectItemValue | null;
};

export type FilterSelectBottomSheetResult = {
  selected: FilterSelectItemValue;
};

export const useFilterSelectBottomSheet = createUseBottomSheetModal<
  FilterSelectBottomSheetResult,
  FilterSelectBottomSheetParams
>(({ param, confirm }) => {
  const [selected, setSelected] = useState(param.selected);
  return (
    <BottomSheetContainer
      title={param.title}
      bottomDocked={{
        type: 'normal',
        paired: false,
        button: {
          onPress: () => {
            if (isNotNil(selected)) {
              confirm({ selected });
            }
          },
          title: '선택 완료',
          state: isNil(selected) ? 'disabled' : undefined,
        },
      }}
    >
      <Flex padding={{ vertical: 12 }}>
        {param.itemList.map(filter => (
          <Flex key={filter.title} padding={{ horizontal: 14 }}>
            <Typography type={'subtitle1'}>{filter.title}</Typography>
            <Flex.Row
              rowGap={8}
              columnGap={8}
              flexWrap={'wrap'}
              padding={{ top: 12 }}
            >
              {filter.list.map(chip => {
                return (
                  <Chip
                    key={chip.queryValue}
                    size={'medium'}
                    state={
                      selected?.queryValue === chip.queryValue
                        ? 'selected'
                        : undefined
                    }
                    onPress={() => {
                      setSelected(chip);
                    }}
                  >
                    {chip.name}
                  </Chip>
                );
              })}
            </Flex.Row>
          </Flex>
        ))}
      </Flex>
    </BottomSheetContainer>
  );
});
